import { resourcesSchema } from '@sevone/insight-connect';

const deviceType = {
  id: 'device',
  schema: resourcesSchema({ allowedResources: [ 'DEVICE' ] })
};

export { deviceType };
